import { render, staticRenderFns } from "./attendanceClassesStaffManageList.vue?vue&type=template&id=2d23071a&scoped=true"
import script from "./attendanceClassesStaffManageList.vue?vue&type=script&lang=js"
export * from "./attendanceClassesStaffManageList.vue?vue&type=script&lang=js"
import style0 from "./attendanceClassesStaffManageList.vue?vue&type=style&index=0&id=2d23071a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23071a",
  null
  
)

export default component.exports